import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-long-right', 'ArrowLongRight', [["path",{"d":"m18 8 4 4m0 0-4 4m4-4H2","key":"svg-0"}]]);